/**
 * logger.ts
 *
 * Simple logger utility for conditional logging based on environment.
 * Logs to console in non-production, can be extended for remote logging.
 */
const ENVIRONMENT=import.meta.env.VITE_ENVIRONMENT
const isDebug = ENVIRONMENT !== "production";
/**
 * logger
 * Provides log, warn, error, and info methods for debugging and error reporting.
 */
const logger = {
  log: (...args: any[]) => {
    if (isDebug) {
      // eslint-disable-next-line no-console
      console.log(...args);
    }
  },
  warn: (...args: any[]) => {
    if (isDebug) {
      console.warn(...args);
    }
  },
  error: (...args: any[]) => {
    if (isDebug) {
      console.error(...args);
    } else {
      // TODO: Send to Firebase, Sentry, etc.
    }
  },
  info: (...args: any[]) => {
    if (isDebug) {
      console.info(...args);
    }
  },
};

export default logger;
